import React, { createContext, useState, useContext, useCallback } from 'react';
import supabase from '../supabase/supabase';

const PlayerContext = createContext(null);

export const PlayerProvider = ({ children }) => {
  const [currentTrack, setCurrentTrack] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [queue, setQueue] = useState([]);

  const playTrack = useCallback(async (track, releaseContext = null) => {
    setCurrentTrack({ ...track, releaseContext });
    setIsPlaying(true);
    
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.user && track.id) {
        // Fire-and-forget telemetry for listening history
        supabase.from('d2f_listening_history').insert({
          user_id: session.user.id,
          drop_id: track.id
        }).then();
      }
    } catch (e) {
      console.error('Failed to log listening history', e);
    }
  }, []);

  const togglePlay = useCallback(() => {
    if (currentTrack) setIsPlaying(p => !p);
  }, [currentTrack]);

  const clearTrack = useCallback(() => {
    setCurrentTrack(null);
    setIsPlaying(false);
  }, []);

  return (
    <PlayerContext.Provider value={{ currentTrack, isPlaying, playTrack, togglePlay, clearTrack, queue, setQueue }}>
      {children}
    </PlayerContext.Provider>
  );
};

export const usePlayer = () => useContext(PlayerContext);